var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-toolbox" }, [
    _c(
      "div",
      {
        staticClass: "buttons-wrapper",
        on: {
          mouseleave: function ($event) {
            _vm.zoomEnabled = false
          },
        },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-center" },
                expression: "{ followCursor: true, placement: 'top-center' }",
              },
            ],
            staticClass: "buttons-wrapper-button",
            attrs: { content: "Start Point" },
            on: { click: _vm.focusStartPoint },
          },
          [_c("span", { staticClass: "material-icons" }, [_vm._v(" home ")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-center" },
                expression: "{ followCursor: true, placement: 'top-center' }",
              },
            ],
            staticClass: "buttons-wrapper-button",
            attrs: { content: "Fullscreen" },
          },
          [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v(" open_with "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-wrapper-separator" }),
        _vm._v(" "),
        _vm.zoomEnabled
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "top-center" },
                    expression:
                      "{ followCursor: true, placement: 'top-center' }",
                  },
                ],
                staticClass: "buttons-wrapper-button",
                attrs: { content: "Zoom in" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("updateScale", _vm.scale + 0.1)
                  },
                },
              },
              [_c("span", { staticClass: "material-icons" }, [_vm._v(" add ")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.zoomEnabled
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "top-center" },
                    expression:
                      "{ followCursor: true, placement: 'top-center' }",
                  },
                ],
                staticClass: "buttons-wrapper-button",
                attrs: { content: "Zoom out" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("updateScale", _vm.scale - 0.1)
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" remove "),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-center" },
                expression: "{ followCursor: true, placement: 'top-center' }",
              },
            ],
            staticClass: "buttons-wrapper-button zoom",
            attrs: { content: "Reset Zoom" },
            on: {
              mouseover: function ($event) {
                _vm.zoomEnabled = true
              },
              click: function ($event) {
                return _vm.$emit("updateScale", 1)
              },
            },
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.getPercentScale) + "%\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "buttons-wrapper-separator" }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-center" },
                expression: "{ followCursor: true, placement: 'top-center' }",
              },
            ],
            staticClass: "buttons-wrapper-button",
            attrs: { content: "Harita" },
            on: { click: _vm.toggleMinimap },
          },
          [_c("span", { staticClass: "material-icons" }, [_vm._v(" map ")])]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }